import { getDiff as _getDiff, applyDiff, rdiffResult } from 'recursive-diff';

export function getDiff(
  old: any,
  newObject: any,
  keepOldVal = false
): rdiffResult[] {
  return _getDiff(old, newObject, keepOldVal);
}
